import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img4 from './img4.png'

const Patio = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Patio Design App to Plan Layouts, Visualize Furniture, and Decorate Outdoors"
        subtitle={<>Design your dream patio with our virtual patio layout app. Test real outdoor furniture, try decor ideas, and create a space you'll love — all from your phone.</>}
        bg={headerBg}
        meta={{
          title: 'Patio Design App | Virtual Patio Layout & Decorating Tool',
          description: 'Create your ideal outdoor space with the top patio design app. Plan layouts, preview real furniture, and decorate virtually using our patio layout planner.'
        }}
        alt="Virtual patio design app showcasing outdoor layout with real furniture and decor"
      />
      <Join
        title="Join 10+ Million Users Designing Patios with Our "
        postfix="Virtual Patio Design App"
        description="Whether you're planning a cozy outdoor lounge, a stylish dining area, or a functional entertaining space, the DecorMatters patio design app helps you bring your vision to life. Visualize furniture layouts, test real patio products, and explore outdoor design ideas — all virtually. Skip the guesswork and confidently design your ideal patio with tools trusted by millions of homeowners and design lovers."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Plan Your Outdoor Space with the Best Patio Layout App</H2>
            </Show>
            <Text>
              The DecorMatters patio layout app lets you arrange outdoor furniture, test decor styles, and experiment with layout ideas in minutes. Upload a photo of your patio or use our built-in templates to get started. From rugs and seating to
              lighting and greenery, our app makes it easy to design a patio that suits your lifestyle and complements your home.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Plan Your Outdoor Space with the Best Patio Layout App</H2>
            </Show>
            <Image src={img1} alt="Patio layout app arranging outdoor furniture, rugs, lighting, and greenery" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Preview and Purchase Outdoor Furniture from Top Retailers</H2>
            </Show>
            <Text>
              The DecorMatters patio design app connects your vision with real products from over 30 top retailers. Shop outdoor sofas, tables, rugs, and lighting from brands like IKEA, Pottery Barn, and World Market — and preview how they look in
              your space before you buy. Whether you're working with a small patio or large backyard, our app helps you stay on budget and make smart decisions with every furniture layout.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Preview and Purchase Outdoor Furniture from Top Retailers</H2>
            </Show>
            <Image src={img2} alt="Virtual patio design preview with products from IKEA, Pottery Barn, and World Market" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Upgrade for Advanced Patio Design Tools and AR Features</H2>
            </Show>
            <Text>
              With DecorMatters Premium, you get access to powerful features that make patio design even easier. Use augmented reality (AR) to preview furniture in your space, organize your favorite items in a wishlist, and erase backgrounds for
              cleaner visuals. Take your outdoor planning to the next level with premium tools designed to help you visualize, compare, and customize every detail of your patio setup.
            </Text>
            <Button onClick={openLogin}>Unlock Premium Tools</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Upgrade for Advanced Patio Design Tools and AR Features</H2>
            </Show>
            <Image src={img3} alt="AR patio design app showing outdoor furniture placement in a real backyard" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Download iOS App
              </ButtonLink>
            </Show>
            <Image src={img4} alt="DecorMatters patio layout app helping users plan and decorate outdoor spaces" />
            <Content>
              <H2>Download the DecorMatters Patio Design App and Start Creating</H2>
              <Text>
                Whether you're dreaming of a relaxing outdoor lounge or a vibrant space for entertaining, the DecorMatters patio design app helps you bring your ideas to life. Arrange furniture, test real products, and customize your layout — all
                virtually. Join millions of users designing patios and start creating your perfect outdoor space today.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Download iOS App
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Patio
